export const formatPrice = (price?: number | null): string => {
  if (price === null || price === undefined || isNaN(Number(price))) {
    return 'N/A';
  }
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};

export const formatWhiskyAge = (years: number): string => {
  if (!years) return '';
  
  // Get last digit and last two digits
  const lastDigit = years % 10;
  const lastTwoDigits = years % 100;
  
  // Polish grammar rules for years
  let form = 'lat';
  
  // 2-4 except for teens (12-14)
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
    form = 'lata';
  }
  
  return `dojrzewa ${years} ${form}`;
};